import { Component } from "@angular/core";

@Component({
    selector: 'app-dummy-redirect',
    template:'',
    standalone: false
})
export class DummyRedirectComponent {

}